module.exports = __webpack_public_path__ + "static/media/influence_1stars.bb5ff5b5.png";